import { useCallback, useState } from 'react';

import { makeHTTPProvider } from 'shared/infra/providers';
import { useTotemInfo } from 'shared/presentation/contexts';

type TVectisCustomer = {
  id: number;
  nomeCompleto: string;
  cpf: string;
  email: string;
  foneCelular: string;
  deveConfirmarDadosContato: boolean;
  biometriaCadastrada: boolean;
};

interface ICustomer {
  id: number;
  fullName: string;
  email: string;
  phone: string;
  document: string;
}
interface IUseCheckDataConfirmationProps {
  onError?: (error: unknown) => void;
}

export default function useCheckDataConfirmation({
  onError,
}: IUseCheckDataConfirmationProps = {}) {
  const { language } = useTotemInfo();
  const [customerData, setCustomerData] = useState<ICustomer | null>(null);

  const isDataConfirmed = useCallback(
    async (params: { document?: string; id?: number }) => {
      try {
        const vectisCustomer = await makeHTTPProvider({
          language,
        }).get<TVectisCustomer>('/clientes/confirmacaoContato', {
          params: {
            cpfCliente: params.document,
            idCliente: params.id,
          },
        });

        if (vectisCustomer.deveConfirmarDadosContato) {
          setCustomerData({
            id: vectisCustomer.id,
            fullName: vectisCustomer.nomeCompleto,
            document: vectisCustomer.cpf,
            email: vectisCustomer.email,
            phone: vectisCustomer.foneCelular,
          });
        }

        return {
          isConfirmed: !vectisCustomer.deveConfirmarDadosContato,
          hasBiometry: vectisCustomer.biometriaCadastrada,
        };
      } catch (error) {
        onError?.(error);
        throw error;
      }
    },
    [language, onError],
  );

  return {
    isDataConfirmed,
    customerData,
    resetData: () => setCustomerData(null),
  };
}
